import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class AuditHistoryFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled: boolean) {
        super(Features.AuditHistory, "MultiJurisdictionCms.Dto.Features.AuditHistoryFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.AuditHistoryFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}